module.exports = __webpack_public_path__ + "img/linkedin-logo-o.9aa5f769.svg";